import { Stack } from "expo-router";
import { StatusBar } from "expo-status-bar";
import React from "react";

import type { PageLayoutProps } from "./types";

const PageLayout = ({
  statusBarStyle = "light",
  children,
}: PageLayoutProps) => (
  <>
    <StatusBar style={statusBarStyle} />

    <Stack.Screen options={{ headerShown: false }} />

    {children}
  </>
);

export default PageLayout;
